<template>
  <div>
    <slot name="title">
      <div class="text-body-2 text-secondary--text d-flex align-center mb-1">
        {{ t('Минимальная категория', options) }}

        <v-btn
          icon
          text
          small
          color="text-info"
          class="ml-1"
          @click="openDialog"
        >
          <v-icon size="20">
            ui-icon-circle-info
          </v-icon>
        </v-btn>
        <v-overlay
          :value="isDialogOpened"
          @click="closeDialog"
        />
        <DialogBottomSheet
          :is-visible="isDialogOpened"
          :width="isMobile ? undefined : 375"
          hide-overlay
          attach=".vue-the-doctors-filters .v-application"
          content-class="rounded-0"
          @dialog-bottom-sheet:change-visible="closeDialog"
        >
          <v-card
            tile
            class="px-2 py-4"
          >
            <div class="pa-2 mb-2">
              <div class="text-h6 mb-2">
                {{ t(DESCRIPTION.category.title, options) }}
              </div>
              <div class="text-body-2 mb-4">
                {{ t(DESCRIPTION.category.description, options) }}
              </div>
              <div class="text-subtitle-2">
                {{ t(DESCRIPTION.secondCategory.title, options) }}
              </div>
              <div class="text-body-2 mb-4">
                {{ t(DESCRIPTION.secondCategory.description, options) }}
              </div>
              <div class="text-subtitle-2">
                {{ t(DESCRIPTION.firstCategory.title, options) }}
              </div>
              <div class="text-body-2 mb-4">
                {{ t(DESCRIPTION.firstCategory.description, options) }}
              </div>
              <div class="text-subtitle-2">
                {{ t(DESCRIPTION.highCategory.title, options) }}
              </div>
              <div class="text-body-2">
                {{ t(DESCRIPTION.highCategory.description, options) }}
              </div>
            </div>
            <v-btn
              color="primary"
              block
              depressed
              @click="closeDialog"
            >
              {{ t('Понятно', options) }}
            </v-btn>
          </v-card>
        </DialogBottomSheet>
      </div>
    </slot>
    <v-chip-group
      :value="doctorFiltersState.category"
      column
      active-class="primary"
      @change="handleChangeChip"
    >
      <v-chip
        v-for="(chip, i) in categoryChips"
        :key="i"
        :value="chip.value"
        :color="chip.value === doctorFiltersState.category ? 'primary' : 'bg-primary'"
        :text-color="chip.value === doctorFiltersState.category ? 'bg-gray-0' : 'primary'"
      >
        {{ t(chip.name, options) }}
      </v-chip>
    </v-chip-group>
  </div>
</template>

<script setup lang="ts">
import { computed, toRefs } from 'vue'
import I18NextVue from 'i18next'
import DialogBottomSheet from 'www/vue_components/common/core/DialogBottomSheet.vue'
import useFiltersStore from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore'
import useDialogManager from 'www/vue_components/common/mixins/DialogManager/useDialogManager'
import type { Filters } from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore.types'

const emit = defineEmits(['input'])
const props = defineProps<{ value: Filters }>()
const { value: doctorFiltersState } = toRefs(props)

const { t, language } = I18NextVue
const options = computed(() => ({ ns: language }))

const DESCRIPTION = {
  category: {
    title: 'Категория',
    description: 'Присваивается на основе оценки экспертной комиссией профессиональных знаний и навыков.',
  },
  secondCategory: {
    title: 'Вторая категория',
    description: 'Владеет техниками диагностики и лечения в своей области.',
  },
  firstCategory: {
    title: 'Первая категория',
    description: 'Обширные знания и умения в своей и смежных областях.',
  },
  highCategory: {
    title: 'Высшая категория',
    description: 'Отлично подготовлен в своей и смежных областях.',
  },
}

const filtersStore = useFiltersStore()
const { isDialogOpened, openDialog, closeDialog } = useDialogManager('ChipGroupCategory')

const isMobile = window.MOBILE_VERSION

const categoryChips: ({ name: string, value: Filters['category'] })[] = [
  { name: 'Вторая', value: 1 },
  { name: 'Первая', value: 2 },
  { name: 'Высшая', value: 3 },
]

const handleChangeChip = (category: Filters['category']) => {
  filtersStore.updateUnsavedFilters({ category })
  emit('input', {
    ...doctorFiltersState.value,
    category,
  })
}
</script>
